module.exports = __webpack_public_path__ + "static/media/white-image.06c781de.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/BrandLogoUpload/images/white-image.png
// module id = 4993
// module chunks = 13